import { de, enUS, es, fr, id, it, Locale, nl, pt, vi } from 'date-fns/locale';

enum Language {
  ENGLISH = 'English',
  SPANISH = 'Spanish',
  FRENCH = 'French',
  ITALIAN = 'Italian',
  GERMAN = 'German',
  DUTCH = 'Dutch',
  PORTUGUESE = 'Portuguese',
  VIETNAMESE = 'Vietnamese',
  INDONESIAN = 'Indonesian',
}

enum I18NextNS {
  COMMON = 'common',
  PAGES = 'pages',
}

export enum LocaleCode {
  EN = 'en-US',
  ES = 'es',
  FR = 'fr',
  IT = 'it',
  DE = 'de',
  NL = 'nl',
  PT = 'pt',
  VI = 'vi',
  ID = 'id',
}

const LanguageToLocale: Record<Language, Locale> = {
  [Language.ENGLISH]: enUS,
  [Language.SPANISH]: es,
  [Language.FRENCH]: fr,
  [Language.ITALIAN]: it,
  [Language.GERMAN]: de,
  [Language.DUTCH]: nl,
  [Language.PORTUGUESE]: pt,
  [Language.VIETNAMESE]: vi,
  [Language.INDONESIAN]: id,
};

const LocaleCodeToLanguage: Record<LocaleCode, Language> = {
  [LocaleCode.EN]: Language.ENGLISH,
  [LocaleCode.ES]: Language.SPANISH,
  [LocaleCode.FR]: Language.FRENCH,
  [LocaleCode.IT]: Language.ITALIAN,
  [LocaleCode.DE]: Language.GERMAN,
  [LocaleCode.NL]: Language.DUTCH,
  [LocaleCode.PT]: Language.PORTUGUESE,
  [LocaleCode.VI]: Language.VIETNAMESE,
  [LocaleCode.ID]: Language.INDONESIAN,
};

export const getLocale = (language: Language): Locale => {
  return LanguageToLocale[language];
};

export const getLanguage = (localeCode: LocaleCode): Language => {
  return LocaleCodeToLanguage[localeCode];
};

export { I18NextNS, Language };
